// eslint-disable-next-line no-restricted-imports
import { getSagaExtension as getSagaExtensionImpl } from "redux-dynamic-modules-saga";
import { logError } from "../../common/logging";

const logSagaError = (e: Error, errorInfo?: any) => {
    logError(e, errorInfo);

    if (process.env.NODE_ENV === "test") {
        // workaround for this issue https://github.com/facebook/jest/issues/11698
        if (typeof fail !== "undefined") {
            fail(e || "error in saga");
        } else {
            throw e ?? new Error("error in saga");
        }
    }
};

export const getSagaExtension = <C>(sagaContext?: C) => getSagaExtensionImpl(sagaContext, logSagaError);
